// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BFA-","field":"styles_field__2skEp","fieldCol":"styles_fieldCol__10b2D","diffCol":"styles_diffCol__38jml","diff":"styles_diff__3xeHK"};